export default "__VITE_ASSET__zF0Mu04U__"